import { getSDSCollectionItem } from 'mini-sds-gateway/lib/services/getSDSCollectionItem';
import { GreenRoomEnum } from './greenRoomEnum';
export async function getGreenRoomVisible() {
    try {
        const greenRoomSettings = await getSDSCollectionItem('GreenRoom');
        if (!greenRoomSettings.isVisible) {
            return GreenRoomEnum.Unseen;
        }

        return greenRoomSettings.isVisible;
    } catch (e) {
        return GreenRoomEnum.Visible;
    }
}
